import React, { createContext, useContext, useEffect, useRef } from "react";
import { io } from "socket.io-client";
import { useAuth } from "./AuthContext";

const SocketContext = createContext();

export function SocketProvider({ children }) {
  const socketRef = useRef(null);
  const { user } = useAuth();

  useEffect(() => {
    if (!socketRef.current) {
      // Use the environment variable if set, otherwise default to localhost
      const socketUrl = process.env.REACT_APP_SOCKET_URL || "http://localhost:8000";
  
      socketRef.current = io(socketUrl, {
        withCredentials: true,
        transports: ["websocket"],
      });
  
      console.log("Socket initialized with URL:", socketUrl);
    }
  
    const socket = socketRef.current;
  
    socket.on("connect", () => {
      console.log(`Connected to WebSocket server: ${socket.id}`);
      if (user?.id) {
        socket.emit("join", user.id);
        console.log(`User ${user.id} joined their WebSocket room.`);
      }
    });
  
    socket.on("disconnect", (reason) => {
      console.log("Socket disconnected:", reason);
    });
  
    socket.on("reconnect", (attemptNumber) => {
      console.log("Socket reconnected:", attemptNumber);
    });
  
    return () => {
      console.log("Cleaning up socket listeners...");
      socket.off("connect");
      socket.off("disconnect");
      socket.off("reconnect");
    };
  }, [user]);

  // Ensure socket is not recreated
  return (
    <SocketContext.Provider value={socketRef.current}>
      {children}
    </SocketContext.Provider>
  );
}

export function useSocket() {
  return useContext(SocketContext);
}
